package com.zaurh.portfolio.main

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.zaurh.portfolio.utils.getPoppinsFont
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.painterResource
import portfolio.shared.generated.resources.Res
import portfolio.shared.generated.resources.app_store_logo
import portfolio.shared.generated.resources.github_logo
import portfolio.shared.generated.resources.github_logo_org
import portfolio.shared.generated.resources.google_play_logo_org
import portfolio.shared.generated.resources.logo_bober
import kotlin.math.log

@Composable
fun ProjectItem(
    maxWidth: Dp,
    title: String,
    desc: String,
    template: DrawableResource,
    logo: DrawableResource,
    logoBackground: Color = Color.White,
    colorFirst: Color,
    colorSecond: Color,
    onGithubClick: () -> Unit = {},
    onGooglePlayClick: () -> Unit = {},
    onAppStoreClick: () -> Unit = {},
    showGooglePlay: Boolean = true,
    showGithub: Boolean = true,
    showAppStore: Boolean = false,
) {
    val imageSize = (maxWidth * 0.3f).coerceIn(200.dp, 300.dp)
    val startPadding = (maxWidth * 0.24f).coerceIn(140.dp, 240.dp)
    val rowHeight = (maxWidth * 0.24f).coerceIn(200.dp, 260.dp)
    val titleSize = (maxWidth.value * 0.02f)
        .coerceIn(14f, 20f)
        .sp
    val descSize = (maxWidth.value * 0.02f)
        .coerceIn(12f, 14f)
        .sp
    val logoSize = (maxWidth * 0.06f).coerceIn(28.dp, 40.dp)
    val socialSize = (maxWidth * 0.06f).coerceIn(28.dp, 40.dp)

    Box(
        modifier = Modifier
            .width(600.dp),
        contentAlignment = Alignment.TopCenter
    ) {
        Row(
            modifier = Modifier
                .padding(top = 30.dp, start = 40.dp, end = 40.dp)
                .clip(RoundedCornerShape(16.dp))
                .background(
                    brush = Brush.verticalGradient(
                        colors = listOf(
                            colorFirst,
                            colorSecond
                        )
                    )
                )
                .padding(
                    start = startPadding,
                    end = 16.dp
                ).height(rowHeight)
        ) {
            Column(
                modifier = Modifier.fillMaxSize(),
                verticalArrangement = Arrangement.SpaceAround
            ) {
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                ) {
                    Box(
                        modifier = Modifier
                            .size(logoSize)
                            .clip(RoundedCornerShape(6.dp))
                            .background(logoBackground)
                            .padding(4.dp)
                    ) {
                        Image(
                            painter = painterResource(logo),
                            contentDescription = null,
                            modifier = Modifier.size(logoSize)
                        )
                    }
                    Spacer(Modifier.width(8.dp))
                    Text(
                        text = title,
                        fontFamily = getPoppinsFont(),
                        fontSize = titleSize,
                        color = Color.White
                    )
                }
                Text(
                    text = desc,
                    lineHeight = descSize,
                    fontFamily = getPoppinsFont(),
                    fontSize = descSize,
                    color = Color.White,
                    fontWeight = FontWeight.Light
                )
                Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.End) {
                    if (showGithub){
                        Image(
                            painter = painterResource(Res.drawable.github_logo_org),
                            contentDescription = null,
                            modifier = Modifier.pointerHoverIcon(PointerIcon.Hand).clip(CircleShape)
                                .size(socialSize).clickable {
                                    onGithubClick()
                                }
                        )
                    }
                    if (showGooglePlay){
                        Spacer(Modifier.width(8.dp))
                        Image(
                            painter = painterResource(Res.drawable.google_play_logo_org),
                            contentDescription = null,
                            modifier = Modifier.pointerHoverIcon(PointerIcon.Hand).clip(CircleShape)
                                .size(socialSize).clickable {
                                    onGooglePlayClick()
                                }
                        )
                    }
                    if (showAppStore){
                        Spacer(Modifier.width(8.dp))
                        Image(
                            painter = painterResource(Res.drawable.app_store_logo),
                            contentDescription = null,
                            modifier = Modifier.pointerHoverIcon(PointerIcon.Hand).clip(CircleShape)
                                .size(socialSize).clickable {
                                    onAppStoreClick()
                                }
                        )
                    }
                }
            }
        }

        Image(
            painter = painterResource(template),
            contentDescription = null,
            modifier = Modifier
                .size(imageSize)
                .align(Alignment.BottomStart)
        )
    }
}